/**
 * Router Providers
 * Провайдеры, которые требуют контекст React Router
 * Должны быть внутри RouterProvider
 */

import { Outlet } from 'react-router';
import { ActionsProvider } from './ActionsProvider';
import { AuthSync } from './AuthSync';
import { NoWishlistDrawer } from './NoWishlistDrawer';

/**
 * Провайдеры, использующие хуки роутера
 * Обязательно должны быть внутри RouterProvider
 */
export function RouterProviders(): JSX.Element {
  return (
    <ActionsProvider>
      {/* Глобальный слушатель auth-событий Supabase. Невизуальный — ловит
          изменения сессии из других вкладок / после OAuth / при истечении
          токена. См. AuthSync.tsx для деталей. */}
      <AuthSync />
      <Outlet />
      <NoWishlistDrawer />
    </ActionsProvider>
  );
}
